import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",

    backgroundColor: tokens.colorNeutralBackground1,
    "@media (min-width: 500px)": {
      height: "100vh",
    },
  },
  main: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    height: "100%",
    backgroundColor: tokens.colorNeutralBackground1,
    "@media (max-width: 499px)": {
      height: "100vh",
      overflowY: "auto",
    },
    "@media (min-width: 500px)": {
      width: "100%",
      ...shorthands.padding("8px", "0px", "20px", "0px"), // Reduced top padding
      ...shorthands.gap("6px"),

      backgroundColor: tokens.colorNeutralBackground2,
    },
  },
  subMainContainer: {
    display: "initial",
    "@media (min-width: 500px)": {
      display: "flex",
      flexDirection: "column",
      ...shorthands.padding("16px", "16px", "24px", "16px"),
      ...shorthands.borderRadius("8px"),
      backgroundColor: tokens.colorNeutralBackground1,
      boxShadow: tokens.shadow2,
      height: "100vh",
      ...shorthands.overflow("hidden"),
    },
    "@media (min-width: 500px) and (max-width: 899px)": {
      marginLeft: "40px",
      marginRight: "40px",
      maxWidth: "100%",
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      ...shorthands.margin("0px", "auto"),
      width: "840px",
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      marginLeft: "200px",
      marginRight: "200px",
      maxWidth: "100%",
    },
    "@media (min-width: 1400px)": {
      ...shorthands.margin("0px", "auto"),
      width: "1040px",
    },
  },

  menuCategoriesContainer: {
    display: "block",

    "@media (min-width: 500px)": {
      ...shorthands.overflow("hidden"),
      scrollbarGutter: "stable",
      "::-webkit-scrollbar": {
        width: "4px",
        height: "4px",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "#ccc",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#888",
      },
      "&:hover": {
        overflowY: "auto",
      },
    },
  },
  stationName: {
    ...shorthands.padding("12px", "18px", "8px", "18px"),
  },
  tabList: {
    display: "flex",
    ...shorthands.padding("0px", "5px"),
    zIndex: 1,
    scrollbarGutter: "stable",
    "::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      ...shorthands.borderRadius("4px"),
    },
    "::-webkit-scrollbar-track": {
      backgroundColor: "#ccc",
      ...shorthands.borderRadius("4px"),
    },
    "::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#888",
    },
    "&:hover": {
      overflowX: "auto",
    },
  },
  tabListContainer: {
    width: "100%",
    backgroundColor: tokens.colorNeutralBackground1,
    paddingTop: "24px",
    paddingBottom: "20px",
    top: "0",
    display: "block",
    zIndex: 1,
    position: "sticky",

    "@media (min-width: 571px)": {
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
      paddingTop: "22px",
    },
    "@media (min-width: 500px) and (max-width: 570px)": {
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
      paddingTop: "22px",
    },
  },
  lastCategory: {
    paddingBottom: "90vh",
  },
  menuCategoryCard: {
    "@media (min-height: 500px)": {
      paddingBottom: "28px",
    },
  },
});
